import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Footer from 'components/footer/footer'
import { mapLanguageToComponentProps } from 'i18n'
import getCustomSupport from 'interview/selectors/custom-support'

const propTypes = {
  jobOpening: PropTypes.shape({
    language: PropTypes.string,
    company: PropTypes.shape({
      privacyPolicy: PropTypes.string,
    }),
  }),
  jobAd: PropTypes.shape({
    privacyPolicy: PropTypes.string,
  }),
  company: PropTypes.shape({
    privacyPolicy: PropTypes.string,
  }),
  customSupport: PropTypes.shape({
    companyName: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
  }),
  i18n: PropTypes.shape({
    candidateFooter: PropTypes.shape({
      termsLink: PropTypes.string,
      accessibilityReportLink: PropTypes.string,
      privacyPolicyLink: PropTypes.string,
    }),
  }).isRequired,
  isEmbeddedPage: PropTypes.bool,
}

const defaultProps = {
  jobOpening: undefined,
  jobAd: undefined,
  company: undefined,
  customSupport: undefined,
  isEmbeddedPage: false,
}

const privacyLink = (i18n, customPrivacyPolicy) => {
  if (customPrivacyPolicy) {
    return customPrivacyPolicy
  }
  return i18n.candidateFooter.privacyPolicyLink
}

const mapStateToProps = state => ({
  jobOpening: state.interview?.jobOpening,
  jobAd: state.careers?.jobAd || state?.jobAd,
  company: state.careers?.company || state.jobAd?.company,
  customSupport: getCustomSupport(state),
})

export function CandidateFooter({
  jobOpening,
  customSupport,
  i18n,
  jobAd,
  company,
  isEmbeddedPage,
}) {
  const customPrivacyPolicy =
    jobOpening?.company?.privacyPolicy ||
    jobAd?.privacyPolicy ||
    company?.privacyPolicy

  return (
    <Footer
      isEmbeddedPage={isEmbeddedPage}
      termsLink={i18n.candidateFooter.termsLink}
      accessibilityReportLink={i18n.candidateFooter.accessibilityReportLink}
      privacyPolicyLink={privacyLink(i18n, customPrivacyPolicy)}
      customSupport={customSupport}
    />
  )
}

CandidateFooter.propTypes = propTypes
CandidateFooter.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  CandidateFooter
)
